import {
  Button,
  ButtonProps,
  Checkbox,
  ChakraProps,
  Flex,
  Grid,
  Heading,
  Text,
} from '@chakra-ui/react';
import { ValidationErrors } from 'final-form';
import { ReactNode } from 'react';
import { Form as FormProps } from '../../types';
import Form, { FormField } from '../Form';
import FormLegalLinks from './FormLegalLinks';
import { validateFieldByType } from '../../lib/utils.validate';
import { useMembershipInfo, useTranslation } from '../../lib/hooks.context';

interface Props extends Omit<FormProps, 'slots'> {
  children?: (closeButtonProps?: ButtonProps) => ReactNode;
  title?: string;
}

const MembershipForm = ({
  type: formType,
  lead,
  children,
  fields,
  id,
  title,
  legal,
  ...rest
}: Props & ChakraProps) => {
  const { membershipSite } = useMembershipInfo();

  const t = useTranslation();
  const onValidate = (values = {}) => {
    const errors: ValidationErrors = fields.reduce(
      (acc, { required, name, type }) => ({
        ...acc,
        [name]: validateFieldByType({ required, type, value: values[name] }),
      }),
      {},
    );

    return errors;
  };
  return (
    <Form
      id={id}
      type={formType}
      py="8"
      validate={onValidate}
      initialValues={membershipSite ? { yhdistys: membershipSite } : undefined}
      {...rest}
    >
      {({ submitting }) => (
        <>
          {title ? (
            <Heading as="h2" variant="h5" mb="2">
              {title}
            </Heading>
          ) : null}
          {lead ? <Text mb="4">{lead}</Text> : null}
          <Grid
            gridTemplateColumns={[
              'repeat(auto-fit, minmax(280px, 1fr))',
              'repeat(auto-fit, minmax(350px, 1fr))',
              'repeat(auto-fit, minmax(396px, 1fr))',
            ]}
            sx={{ 'fieldset:nth-of-type(3)': { gridColumn: '1/-1' } }}
            gridColumnGap="6"
            gridRowGap="1"
          >
            {fields.map((field) => (
              <FormField key={field.name} {...field} />
            ))}
          </Grid>
          <Flex justifyContent="flex-end" gridGap="6" pt="2">
            {children ? children({ disabled: submitting }) : null}
            <Button
              type="submit"
              variant="solidGreen"
              disabled={submitting}
              isLoading={submitting}
              loadingText={t('button_submitting')}
            >
              {t('button_submit')}
            </Button>
          </Flex>
          {legal && legal.length > 0 ? <FormLegalLinks legal={legal} /> : null}
        </>
      )}
    </Form>
  );
};

export default MembershipForm;
